import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Facebook, Store } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { STORE } from "@/lib/store";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="bg-[#0a0a0a] text-white mt-24">
      <div className="mx-auto max-w-7xl px-4 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src="/logo.png" alt="DCS Électro" className="h-14 w-auto" />
          <p className="mt-5 text-sm text-gray-400 leading-relaxed">{t("footer.tagline")}</p>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-5">{t("footer.shop")}</h4>
          <ul className="space-y-3 text-sm text-gray-300">
            <li><Link to="/boutique" className="hover:text-white">{t("footer.allProducts")}</Link></li>
            <li><Link to="/boutique?brand=Frigidaire" className="hover:text-white">Frigidaire</Link></li>
            <li><Link to="/boutique?brand=Vesta" className="hover:text-white">Vesta</Link></li>
            <li><Link to="/blog" className="hover:text-white">{t("footer.articles")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-5">{t("footer.contactUs")}</h4>
          <ul className="space-y-3 text-sm text-gray-300">
            <li className="flex gap-3"><MapPin size={17} className="text-brand-red shrink-0" /><span>{STORE.address}<br />{STORE.city}</span></li>
            <li className="flex gap-3"><Phone size={17} className="text-brand-red shrink-0" /><a href={`tel:${STORE.phoneRaw}`} className="hover:text-white">{STORE.phone}</a></li>
            <li className="flex gap-3"><Mail size={17} className="text-brand-red shrink-0" /><a href={`mailto:${STORE.email}`} className="hover:text-white">{STORE.email}</a></li>
            <li className="flex gap-3"><Clock size={17} className="text-brand-red shrink-0" /><span>{STORE.hours}</span></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-5">{t("footer.certified")}</h4>
          <p className="text-sm text-gray-400">{t("footer.certifiedText")}</p>
          <div className="mt-5 flex flex-col gap-3">
            <a href={STORE.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white" data-testid="footer-facebook">
              <Facebook size={16} className="text-brand-red" /> Suivez-nous sur Facebook
            </a>
            <a href={STORE.friperie} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white" data-testid="footer-friperie">
              <Store size={16} className="text-brand-red" /> Friperie Lyly (2e étage)
            </a>
          </div>
          <Link to="/admin/login" className="inline-block mt-5 text-xs text-gray-600 hover:text-gray-400" data-testid="footer-admin-link">{t("footer.admin")}</Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs text-gray-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {STORE.name}. {t("footer.rights")}</span>
          <span>{t("footer.made")} · <a href={STORE.agency} target="_blank" rel="noopener noreferrer" className="hover:text-white underline underline-offset-2" data-testid="footer-carthisoft">Site web par Carthisoft</a></span>
        </div>
      </div>
    </footer>
  );
};
